import { useTranslation } from 'react-i18next'

import { Button, Flex, HStack, VStack } from '@chakra-ui/react'
import { wwtMemo } from '@wwt/custom/wwt'

import { FeatureIsNotImplemented } from '@wwt/ui/components'

import { ReservationButtonByOfferStatus } from '@/features/ReservationButtons'
import { useMobile } from '@/shared/lib/hooks/useBreakpoints'

import { useRoomSection } from '../../model/useRoomSection'
import { TabSection } from '../../types'
import { GroupWithFeatures } from '../GroupWithFeatures.tsx'
import * as Layout from './layout'

export const RoomSection = wwtMemo(
	({ offer, onShowOfferConfiguration }: TabSection) => {
		const { t } = useTranslation('room-page')

		const {
			roomFeatureGroups,
			hotelFeatureGroups,
			description,
			roomName,
			isOfferConfigurationDisabled
		} = useRoomSection(offer)

		const isMobile = useMobile()

		return (
			<VStack
				gap="2rem"
				px={{ base: '1.25rem', md: 0 }}
				alignItems="flex-start"
			>
				<VStack
					gap="1rem"
					alignItems="flex-start"
				>
					<HStack
						gap="1.5rem"
						alignItems="center"
					>
						<Layout.Title>{roomName}</Layout.Title>
						<FeatureIsNotImplemented>
							<Button
								data-wwt-id="room-offer__room-section-show-photos--button"
								variant="link"
								color="primary.100"
								fontSize="lg"
								fontWeight="500"
								textUnderlineOffset={4}
							>
								{t('tabs.showPhotos')}
							</Button>
						</FeatureIsNotImplemented>
					</HStack>
					<Layout.Body>{description}</Layout.Body>
				</VStack>

				<VStack
					gap="2rem"
					align="flex-start"
				>
					<GroupWithFeatures
						groupsWithFeatures={roomFeatureGroups}
						onShowOfferConfiguration={onShowOfferConfiguration}
						i18nGroupKey="groups.roomGroup"
						defaultGroupName={t('defaultGroupName', {
							ns: 'translation'
						})}
						isDisabledOfferConfiguration={isOfferConfigurationDisabled}
					/>

					<GroupWithFeatures
						groupsWithFeatures={hotelFeatureGroups}
						onShowOfferConfiguration={onShowOfferConfiguration}
						i18nGroupKey="groups.hotelGroup"
						defaultGroupName={t('defaultGroupName', {
							ns: 'translation'
						})}
						isDisabledOfferConfiguration={isOfferConfigurationDisabled}
					/>
				</VStack>

				{!isMobile && (
					<Flex
						justifyContent="flex-end"
						w="100%"
						mt={{ base: '3.25rem', xl: '4.5rem' }}
					>
						<ReservationButtonByOfferStatus
							className="w-[18.5rem] xl:w-[25.5rem]"
							offer={offer}
						/>
					</Flex>
				)}
			</VStack>
		)
	}
)
